import React from "react";
import { observer } from "mobx-react";
import SuccessIconDisplay from "src/components/ui/SuccessIconDisplay";
import PlatoFooter from "../../assets/images/PlatoFooter.png";
import { Button } from "src/components/ui/Button";
import { useTranslation } from "react-i18next";
import { useFooterLogo } from "src/hooks/useFooterLogo";

const Success = observer(() => {
  const { t } = useTranslation();
  const footerLogoUrl = useFooterLogo();
  const footerLogoSrc = footerLogoUrl || PlatoFooter;
  const footerLogoClasses = footerLogoUrl
    ? "max-h-12 w-auto max-w-[min(240px,100%)] object-contain object-center"
    : "";
  const returnUrl = sessionStorage.getItem("returnUrl") === "null" ? null : sessionStorage.getItem("returnUrl");
  return (
    <div className="custom-container">
      <div className="flex justify-between flex-col items-center h-full pt-[10px]">
        <div className="pt-8">
          <div className="px-10">
            <div className="text-h5 font-bold mb-2 text-flow-heading">
              {t('success.title')}
            </div>
            <div className="text-body text-Gray900">
              {t('success.subtitle')}
            </div>
          </div>
          <div className="w-[313px] h-[313px]">
            <div className="mt-4 relative">
              <SuccessIconDisplay />
            </div>
          </div>
          <div className="mt-2 px-3 py-3 text-center z-10">
            {returnUrl && <div className="text-xxs text-Gray900">{t('success.redirectNotice')}</div>}
          </div>
          <div className="items-center py-3 bottom-0">
            {
              returnUrl && <Button
                href={returnUrl}
                target="_parent"
                className="w-full"
                variant="primaryWithoutIcon"
              >
                {t('success.goHome')}
              </Button>
            }
          </div>
        </div>
        <div className="bg-Gray100 w-full px-5 pt-4 pb-6 rounded-t-[16px]">
          {!footerLogoUrl && <div className="text-xxs text-Gray400">{t('success.verifiedWith')}</div>}
          <div className={`text-h6 text-Gray900 flex justify-center ${footerLogoUrl ? "" : "mt-1"}`}>
            <img src={footerLogoSrc} alt={t('common.verification')} className={footerLogoClasses} />
          </div>
        </div>
      </div>
    </div>
  );
});

export default Success;
